import { inject, Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { filter, tap } from 'rxjs/operators';
import { NotificationsService } from 'src/app/core/services/notifications.service';
import { NotificationStateModel } from './notifications.state.model';
import { NotificationItemsResponseDto, NotificationMessageDto } from 'src/app/shared/dtos/notification-item.dto';
import { GetNotifications } from './notifications.actions';
import { Observable } from 'rxjs';

@State({
  name: 'notifications',
  defaults: {
    notifications: []
  }
})
@Injectable()
export class NotificationState {
  notificationService = inject(NotificationsService);

  @Selector()
  static getNotifications(state: NotificationStateModel): NotificationMessageDto[] {
    return state.notifications;
  }

  @Action(GetNotifications)
  getNotifications(ctx: StateContext<NotificationStateModel>, action: GetNotifications): Observable<NotificationItemsResponseDto | null> | void {
    const notificationState = ctx.getState();

    if (!action.forceRefresh && notificationState.notifications && notificationState.notifications.length > 0) {
      return;
    }

    return this.notificationService.getNotifications().pipe(
      filter((notification): notification is NotificationItemsResponseDto => notification !== null && notification.messages.length > 0),
      tap(notifications => {
        const state = ctx.getState();
        ctx.setState({
          ...state,
          notifications: notifications.messages
        });
      })
    );
  }
}
